import { generatePath } from 'react-router-dom';
import URL from '../../../../constants/api-constants';
import http from '../../../../store/http/http-common';
import { toast } from 'react-toastify';

export const changeFaultControlAction = async (
  controller_id: string,
  setup_command: string,
  item_command: string,
  newValue: boolean
) => {
  try {
    await http.put(
      generatePath(URL.CONTROLLER_FAULT_CONTROL, {
        id: controller_id,
      }),
      { setup_command, item_command, value: newValue }
    );
    toast.success('Action successfully executed');
  } catch (error) {
    toast.error(error.message);
  }
};
